import React from 'react';
import { PropTypes } from 'prop-types';

import { useGetAggregatedProviderDataQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import { DashboardSection, InfoCard } from '../common-components';
import { Loader } from 'components';
import { Box, Grid } from '@mui/material';

const ProviderActionsToTake = ({ onListFilter }) => {
    const { data: aggregatedProviderData = {}, isFetching: providerDataLoader } =
        useGetAggregatedProviderDataQuery();

    return (
        <DashboardSection title={texts.ACTIONS_TO_TAKE}>
            <Loader loading={providerDataLoader} marginTop={10}>
                <Box width="100%" marginBottom={3}>
                    <Grid container spacing={2}>
                        <InfoCard
                            onClick={onListFilter({ pendingSGPSignature: 1 }, 'subscriptions')}
                            number={aggregatedProviderData.nr_subscriptions_pending_sgp_signature}
                            label={texts.SUBSCRIPTIONS_TO_BE_SIGNED}
                        />
                        <InfoCard
                            onClick={onListFilter({ conventionPartiallySigned: 1 }, 'distributors')}
                            number={aggregatedProviderData.nr_conventions_partially_signed}
                            label={texts.CONVENTIONS_TO_BE_SIGNED}
                        />
                    </Grid>
                </Box>
            </Loader>
        </DashboardSection>
    );
};

ProviderActionsToTake.propTypes = { onListFilter: PropTypes.func };

export default ProviderActionsToTake;
